import { render } from "./EditCustomField.vue?vue&type=template&id=c4b50a18&scoped=true"
import script from "./EditCustomField.vue?vue&type=script&lang=js"
export * from "./EditCustomField.vue?vue&type=script&lang=js"

import "./customField.scss?vue&type=style&index=0&id=c4b50a18&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b50a18"]])

export default __exports__